import { HttpClient } from '../../httpClient'
import type { OpalApi } from '../../schema'

export const updateWorkflowAssignment: OpalApi<
  'UpdateWorkflowAssignmentV3',
  200
> = async ({
  params,
  requestBody,
}: Parameters<OpalApi<'UpdateWorkflowAssignmentV3', 200>>[0] = {}) => {
  const url = new URL(
    `/v3/workflow_assignments/${params?.path.workflow_assignment_id}`,
    window.location.origin
  )
  return HttpClient()
    .patch(url.toString(), requestBody)
    .then((res) => res.data)
}
